module.exports = __webpack_public_path__ + "img/EMC_H_1.231f314c.png";